<template>
  <PageView :loading="loading" :logo="logo" header-class="bg-light" class="bg-light">
    <ScrollDownIndicatorComponent ref="scrollDownIndicator" />
    <div class="card" v-if="participation">
      <div id="registration-main-card" class="card-body pt-0 px-0">
        <TravelBannerComponent :participation="participation" />
        <div class="row justify-content-center m-0 m-md-3 mt-0">
          <h2 class="card-title text-center my-4 d-flex justify-content-between flex-column flex-md-row">
            <div class="col text-start">
              <router-link custom :to="{name: 'home'}" v-slot="{ navigate }">
                <button
                  class="btn btn-outline-primary text-nowrap d-none d-md-block"
                  @click="navigate"
                >
                  <i class="fa-solid fa-angle-left me-2"></i> Retour
                </button>
              </router-link>
            </div>
            <div class="">Récapitulatif</div>
            <div class="col"></div>
            <div class="col text-start d-block d-md-none mt-2">
              <router-link custom :to="{ name: 'home' }" v-slot="{ navigate }">
                <button class="btn btn-outline-primary text-nowrap" @click="navigate">
                  <i class="fa-solid fa-angle-left me-2"></i> Retour
                </button>
              </router-link>
            </div>
          </h2>
          <TravelEditSummary v-model="participation" />
        </div>
      </div>
    </div>
  </PageView>
</template>
<script lang="ts" setup>
  import { onMounted, ref, computed } from 'vue';
  import { useNotificationsStore } from '@/stores/notificationStore';
  import { getPictureUrl } from '@/compositions/helper';
  import travelApi from '@/api/travelApi'
  import PageView from '@/views/PageView.vue';
  import TravelEditSummary from '@/views/user/travel/TravelEditSummary.vue';
  import { useRouter } from 'vue-router';

  const router = useRouter()
  const notificationsStore = useNotificationsStore();

  const loading = ref(true);
  const participation = ref<UserParticipation|null>(null);

  const props = defineProps<{ id?: number; slug?: string }>()

  const logo = computed(() => {
    if (participation.value?.travel.logo?.key) {
      return getPictureUrl(participation.value.travel.logo.key);
    }

    return undefined;
  });

  onMounted(() => {
    const loadParticipation = props.id
      ? travelApi.getParticipation(Number(props.id))
      : props.slug
        ? travelApi.getParticipationBySlug(props.slug)
        : null

    if (!loadParticipation) {
      router.push({ name: 'home' })
      return
    }

    loadParticipation.then((response) => {
      participation.value = response.data;
    }).catch((error: Error) => {
      notificationsStore.notifyError('Erreur lors du chargement de la page',error.message);
      router.push({ name: 'home' });
    }).finally(() => {
      loading.value = false;
    });
  });
</script>
